import {
  type CamelCase,
  type Languages,
  ValidLanguages,
  type Currency,
  type StoreCode
} from '../types';
import { toCamelCase } from '../utils/toCamelCase';

export * from './offer';

// TODO(AssetLibrary-Rama): Don't merge this into the epic or things may break.
export const DYNAMIC_PAGE_URL = process.env.NEXT_PUBLIC_DYNAMIC_PAGE_URL || 'https://drinkag1.com';

// still might be needed for debugging
// export const DYNAMIC_PAGE_URL =
//  'https://vercel-customer-portal-git-mpmc-771-benefits-list.vercel-preview.drinkag1.com';

export const symbolsCurrency: Readonly<Record<Currency, string>> = {
  USD: '$',
  GBP: '£',
  EUR: '€',
  YEN: '¥',
  AUD: '$',
  NZD: '$'
};

export const storeCurrency: Readonly<Record<StoreCode, Currency>> = {
  us: 'USD',
  eu: 'EUR',
  uk: 'GBP',
  jp: 'YEN',
  qa: 'USD',
  dev: 'USD',
  eud: 'EUR',
  ukd: 'GBP',
  aud: 'AUD',
  nzd: 'NZD'
};

type CamelCasedLanguages = CamelCase<Languages>;

const locales = ValidLanguages.reduce(
  (acc, item) => {
    acc[toCamelCase(item as string) as CamelCasedLanguages] = item;

    return acc;
  },
  {} as Record<CamelCasedLanguages, Languages>
);

export const LOCALE_TO_SHOPIFY_COUNTRY_CODE = {
  [locales.us]: 'US',
  [locales.apacUs]: 'US',
  [locales.au]: 'AU',
  [locales.nz]: 'NZ',
  [locales.gb]: 'GB',
  [locales.eu]: 'ES', // since EU isn't a country code
  [locales.de]: 'DE',
  [locales.se]: 'SE',
  [locales.nl]: 'NL',
  [locales.es]: 'ES',
  [locales.fr]: 'FR'
} as const;

export type ShopifyCountryCode =
  (typeof LOCALE_TO_SHOPIFY_COUNTRY_CODE)[keyof typeof LOCALE_TO_SHOPIFY_COUNTRY_CODE];
